





















































































































































// import UiCalendar from '../../Calendar/Calendar.vue'
import config from "@/config";
import {
  CONF_MESSENGER_MAX,
  CONF_MESSENGER_VK,
  CONF_MESSENGER_TG,
  CONF_MESSENGER_VB,
  CONF_MESSENGER_TT,
  MSGR_MAX,
  MSGR_TG,
  MSGR_TT,
  MSGR_VK,
  MSGRS_LIST,
  STUD_FIELDS_VALS,
  MSGR_VB,
  MSGR_DC,
  CONF_MESSENGER_DISCORD,
  CONF_CLEINT_LOGO_PREFIX,
  CONF_DEFAULT_FILTER_LIST,
} from "@/constants";
import searchTableConfig from "@/components/Newsletters/CreateForm/searchTable";
import { ActiveFieldOptions } from "@/components/Ui/ActiveForm/BZCore/ActiveField";
import SelectField, {
  SelectFieldOptions,
} from "@/components/Ui/ActiveForm/BZCore/Fields/SelectField";
import { IFilters } from "@/components/Ui/ActiveTable/BZCore/ActiveTable";
import StringField from "@/components/Ui/ActiveForm/BZCore/Fields/StringField";
import Vue, { VueConstructor } from "vue";
import { DateTime } from "luxon";
import StudentsActiveTableConfig from "@/activeTables/Students/FullList";
import activeTable from "@/components/Ui/ActiveTable/ActiveTable.vue";
import UiFiltersAndActions from "@/components/Ui/FiltersAndActions/FiltersAndActions.vue";
import UiTable from "@/components/Ui/Table/Table.vue";
import { coerce } from "@/lib/array";
import _ from "lodash";
import { Dictionary } from "vuex";
import {
  TableOptions,
  TableColOptions,
} from "@/components/Ui/ActiveForm/BZCore/Table/Table";
import Student from "@/models/Students/Student";
import Mailing from "@/models/mailing/mailing";

import FirstName from "@/components/Students/Table/cols/firstName.vue";
import LastName from "@/components/Students/Table/cols/lastName.vue";
import MiddleName from "@/components/Students/Table/cols/middleName.vue";
import Messengers from "@/components/Students/Table/cols/messengers.vue";
import StudentsForm from "@/components/Students/Table/cols/form.vue";
import Faculty from "@/components/Students/Table/cols/faculty.vue";
import Course from "@/components/Students/Table/cols/course.vue";
import Group from "@/components/Students/Table/cols/group.vue";
import Financing from "@/components/Students/Table/cols/financing.vue";
import Program from "@/components/Students/Table/cols/program.vue";
import Term from "@/components/Students/Table/cols/term.vue";
import State from "@/components/Students/Table/cols/state.vue";
import HalfYear from "@/components/Students/Table/cols/halfYear.vue";
import Semester from "@/components/Students/Table/cols/semester.vue";
import Specialty from "@/components/Students/Table/cols/specialty.vue";
import IsAuth from "@/components/Students/Table/cols/isAuth.vue";
import StudentDetailRow from "@/components/Students/Table/StudentDetailRow.vue";
import StudentIndexColumn from "@/components/Students/Table/StudentIndexColumn.vue";

import rcptTableConfig from "@/activeTables/Newsletters/recipients";
import Radio from "@/components/Ui/Radio/Radio.vue";

export default (Vue as VueConstructor<
  Vue & {
    $refs: {
      calendar: { months: DateTime[] };
      filters: { reset: () => void };
    };
  }
>).extend({
  name: "SecondStep",
  components: {
    activeTable,
    UiFiltersAndActions,
    UiTable,
    Radio,
  },
  props: {
    scope: {} as () => { mailingId: string },
    mailingId: String,
  },
  data() {
    return {
      pageBaseUrl: "/newsletters/create",
      loading: false,
      forAllStitching: false,
      searchTableConfig,
      sendEvery: true,
      date: "",
      time: "",
      searchData: [],
      filtersConfig: {
        pageName: this.$t("labels.search_and_filters"),
        searchFormButtonText: this.$t("labels.search_form_button_text"),
        searchForm: {
          inputs: {
            last_name: {
              type: StringField,
              label: this.$t("labels.surname"),
            },
            first_name: {
              type: StringField,
              label: this.$t("labels.name"),
            },
            middle_name: {
              type: StringField,
              label: this.$t("labels.middle_name"),
            },
            email: {
              type: StringField,
              label: this.$t("labels.email"),
            },
          },
          steps: [
            { map: [["last_name", "first_name", "middle_name", "email"]] },
          ],
        },
        filters: {},
      } as IFilters,
      tableConfig: {
        cols: {
          last_name: {
            label: this.$t("labels.cols.last_name"),
            component: LastName,
            sortable: true,
          },
          first_name: {
            label: this.$t("labels.cols.first_name"),
            component: FirstName,
            sortable: true,
          },
          middle_name: {
            label: this.$t("labels.cols.middle_name"),
            component: MiddleName,
            sortable: true,
          },
          messengers: {
            label: this.$t("labels.cols.messengers"),
            component: Messengers,
          },
          id: {
            label: this.$t("labels.cols.id"),
            isModel: true,
            sortable: true,
          },
          form: {
            label: this.$t("labels.cols.form"),
            component: StudentsForm,
            sortable: true,
          },
          faculty: {
            label: this.$t("labels.cols.faculty"),
            component: Faculty,
            sortable: true,
          },
          course: {
            label: this.$t("labels.cols.course"),
            component: Course,
            sortable: true,
          },
          group: {
            label: this.$t("labels.cols.group"),
            component: Group,
            sortable: true,
          },
          financing: {
            label: this.$t("labels.cols.financing"),
            component: Financing,
            sortable: true,
          },
          program: {
            label: this.$t("labels.cols.program"),
            component: Program,
            sortable: true,
          },
          term: {
            label: this.$t("labels.cols.term"),
            component: Term,
            sortable: true,
          },
          state: {
            label: this.$t("labels.cols.state"),
            component: State,
            sortable: true,
          },
          half_year: {
            label: this.$t("labels.cols.half_year"),
            component: HalfYear,
            sortable: true,
          },
          semester: {
            label: this.$t("labels.cols.semester"),
            component: Semester,
            sortable: true,
          },
          specialty: {
            label: this.$t("labels.cols.specialty"),
            component: Specialty,
            sortable: true,
          },
          is_auth: {
            label: this.$t("labels.cols.is_auth"),
            component: IsAuth,
            sortable: true,
          },
        },
        detailRowComponent: StudentDetailRow,
      } as TableOptions,
      searchTablePagination: {
        pageSize: 20,
        currentPage: 1,
        totalItems: 43988,
      },
      searchSort: {},
      defaultCols: ["last_name", "first_name", "middle_name", "messengers"],
      checkedStuds: [] as Student[],
      showRecipsList: false,
      rcptTableConfig,
      hasFilters: false,
    };
  },
  computed: {
    mailing(): Mailing | false {
      if (this.mailingId) {
        return this.$store.state.mailing.mailings[this.mailingId];
      } else {
        return false;
      }
    },
    checkedStudsKeys(): string[] {
      let keys = [];
      for (const stud of this.checkedStuds) {
        keys.push(stud.id);
      }
      return keys;
    },
    shownColumns(): any {
      const cols: Dictionary<TableColOptions> = {
        _tableindex: { label: "№", component: StudentIndexColumn },
      };
      for (const fieldName of this.defaultCols) {
        if (Object.keys(this.tableConfig.cols).indexOf(fieldName) !== -1) {
          cols[fieldName] = this.tableConfig.cols[fieldName];
        }
      }
      return cols;
    },
    recipientsCounter(): number {
      if (this.mailing) {
        return this.mailing.getRcptNum();
      } else {
        return 0;
      }
    },
    msgrNum(): number {
      if (this.mailing) {
        return this.mailing.getMsgrNum();
      } else {
        return 0;
      }
    },
  },
  methods: {
    next() {
      if (this.recipientsCounter > 0) {
        this.$emit("next");
      } else {
        // @ts-ignore
        // @ts-ignore
        this.$message({
          // @ts-ignore
          message: this.$t("newsletters.select_recipients"),
          type: "warning",
        });
      }
    },
    prev() {
      this.$emit("prev");
    },
    async createMailing() {
      /* if (!this.scope.mailing_id) {
          // @ts-ignore
          let response = await this.$store.dispatch('mailing/create', {text: this.scope.text})
          // @ts-ignore
          this.mailingId = response.mailing_id
          this.scope.mailing_id = this.mailingId;
          await this.$store.dispatch('mailing/get', this.mailingId)
        } else {
          this.mailingId = this.scope.mailing_id;
        } */
    },
    onInput(value: any): void {
      this.$emit("input", { date: this.date, time: this.time });
    },
    async reloadMailing(): Promise<void> {
      if (this.mailingId) {
        await this.$store.dispatch("mailing/get", this.mailingId);
      }
    },
    async loadFiltersValues(): Promise<void> {
      try {
        let filters: { [key: string]: string[] } = _.cloneDeep(
          await this.$store.dispatch("students/loadFieldVals")
        );
        const optionalFilters = [
          "form",
          "filial",
          "financing",
          "program",
          "term",
          "state",
          "half_year",
          "semester",
          "specialty",
          "gender",
          "foreigner",
          "need_hostel",
          "status",
          "edu_honors",
          "target_enrollment",
          "target_organization",
          "plan_code",
          "plan_cname",
          "type_edu",
          "speciality",
          "citizen",
          "hostel",
          "prog_asp",
          "prog_mag",
          "qualif",
          "competition",
          "status",
          "sync_time",
          "msgrs",
        ];

        const defaultFilterList = config(CONF_DEFAULT_FILTER_LIST);

        if (defaultFilterList) {
          const defaultFilters = defaultFilterList.split(',');

          defaultFilters.forEach((item: any) => {
            if (optionalFilters.includes(item)) {
              const idx = optionalFilters.indexOf(item);

              optionalFilters.splice(idx, 1);
            }
          })
        }

        if (config(CONF_CLEINT_LOGO_PREFIX) === "kuban") {
          optionalFilters.shift();
        }

        for (const filter in STUD_FIELDS_VALS) {
          if (filters[filter]) {
            try {
              if (STUD_FIELDS_VALS[filter].sort) {
                filters[filter] = coerce(filters[filter], STUD_FIELDS_VALS[
                  filter
                ].sort as string[]);
              }
            } catch (error) {
              console.error("loadFiltersValues -> coerce", error);
              continue;
            }
            let values = [];
            for (const val of filters[filter]) {
              let label = val;
              if (
                STUD_FIELDS_VALS[filter].dict &&
                STUD_FIELDS_VALS[filter].dict![val]
              ) {
                label = STUD_FIELDS_VALS[filter].dict![val];
              }
              values.push({ label, value: val });
            }

            let optional = optionalFilters.some((item) => item === filter);

            this.filtersConfig.filters[filter] = {
              label: STUD_FIELDS_VALS[filter].label,
              type: SelectField,
              options: {
                values,
                multiSelect: true,
              },
              optional,
            } as ActiveFieldOptions<SelectFieldOptions>;
          } else {
            let optional = optionalFilters.some((item) => item === filter);
            this.filtersConfig.filters[filter] = {
              label: STUD_FIELDS_VALS[filter].label,
              type: SelectField,
              options: {
                values: [],
                multiSelect: true,
                disabled: true,
              },
              placeholder: this.$t("labels.no_data"),
              optional,
            } as ActiveFieldOptions<SelectFieldOptions>;
          }
        }

        this.filtersConfig.filters.msgrs = {
          label: this.$t("labels.cols.messengers"),
          type: SelectField,
          options: {
            values: [],
            multiSelect: true,
          },
          optional: true,
        } as ActiveFieldOptions<SelectFieldOptions>;

        if (this.getActiveSocial(CONF_MESSENGER_MAX)) {
          this.pushSocial('MAX', MSGR_MAX);
        }
        if (this.getActiveSocial(CONF_MESSENGER_VK)) {
          this.pushSocial(this.$t("common.socials.vk").toString(), MSGR_VK);
        }
        if (this.getActiveSocial(CONF_MESSENGER_TG)) {
          this.pushSocial(this.$t("common.socials.tg").toString(), MSGR_TG);
        }
        if (this.getActiveSocial(CONF_MESSENGER_VB)) {
          this.pushSocial(this.$t("common.socials.vb").toString(), MSGR_VB);
        }
        if (this.getActiveSocial(CONF_MESSENGER_TT)) {
          this.pushSocial(this.$t("common.socials.tt").toString(), MSGR_TT);
        }
        if (this.getActiveSocial(CONF_MESSENGER_DISCORD)) {
          this.pushSocial(this.$t("common.socials.dc").toString(), MSGR_DC);
        }

        if (this.filtersConfig.filters.for_all) {
          delete this.filtersConfig.filters.for_all;
        }
      } catch (error) {
        console.error("loadFiltersValues", error);
      }
    },
    getActiveSocial(key: string) {
      return config(key) && config(key) === true;
    },
    pushSocial(name: string, value: string) {
      this.filtersConfig.filters.msgrs.options.values.push({
        label: name,
        value: value,
      });
    },
    onFiltersChanged: _.debounce(async function(query: any): Promise<void> {
      let emptyKeys: string[] = [];
      for (let key in query) {
        if (Array.isArray(query[key]) && !query[key].length) {
          emptyKeys.push(key);
          continue;
        }
        if (query[key] === "") {
          emptyKeys.push(key);
        }
      }

      for (let key of emptyKeys) {
        delete query[key];
      }
      // @ts-ignore
      let self = this as any;
      self.loading = true;
      self.hasFilters = Object.keys(query).length ? true : false;
      try {
        if (self.mailingId) {
          await self.$store.dispatch("mailing/removeFilter", {
            mailing_id: self.mailingId,
            query: { filter: "query" },
          });
          if (Object.keys(query).length) {
            await self.$store.dispatch("mailing/addFilter", {
              mailing_id: self.mailingId,
              query,
            });
          }
          await self.reloadMailing();
          await self.reloadRcptsTable();
        }
      } catch (error) {
        console.error("LOG: error", error);
        self.$notify.error({
          // @ts-ignore
          title: this.$t("labels.error"),
          message: self.$t("newsletters.can_not_add_users"),
        });
      }
      self.loading = false;
    }, 500),
    async onSearchStudChecked(studs: any) {
      try {
        this.checkedStuds = studs;
        const lsn_ids = studs.map((stud: Student) => {
          return stud.id;
        });
        await this.$store.dispatch("mailing/removeFilter", {
          mailing_id: this.mailingId,
          query: { filter: "id" },
        });
        if (lsn_ids.length) {
          await this.$store.dispatch("mailing/addIds", {
            mailing_id: this.mailingId,
            lsn_ids,
          });
        }
        await this.reloadMailing();
        /* this.$notify({
            // @ts-ignore
            title: this.$t('labels.success'),
            // @ts-ignore
            message: this.$t('labels.user_added_success'),
            type: 'success'
          }); */
      } catch (error) {
        console.error("LOG: onSearchStudChecked -> error", error);
        // @ts-ignore
        this.$notify.error({
          // @ts-ignore
          title: this.$t("labels.error"),
          // @ts-ignore
          message: this.$t("newsletters.can_not_add_users"),
        });
      }
    },
    toggleRecipsList() {
      this.showRecipsList = !this.showRecipsList;
    },
    async clearRecipsList() {
      await this.$store.dispatch("mailing/removeFilter", {
        mailing_id: this.mailingId,
        query: { filter: "id" },
      });
      this.checkedStuds = [];
      this.$refs.filters.reset();
      this.$notify({
        // @ts-ignore
        title: this.$t("labels.success"),
        // @ts-ignore
        message: this.$t("newsletters.users_list_cleared"),
        type: "success",
      });
    },
    onSearchReset() {
      this.searchData = [];
    },
    async reloadRcptsTable() {
      // @ts-ignore
      await this.$refs.rcptsTable.loadList();
    },
    async sendToEvery() {
      if (this.sendEvery && this.mailingId) {
        await this.$store.dispatch("mailing/addFilter", {
          mailing_id: this.mailingId,
          query: { msgrs: MSGRS_LIST },
        });
        await this.reloadMailing();
        console.log("sendToEvery");
      }
    },
    async onSendEveryChange(val: boolean) {
      if (!val) {
        await this.$store.dispatch("mailing/removeFilter", {
          mailing_id: this.mailingId,
          query: { filter: "query" },
        });
        await this.$store.dispatch("mailing/removeFilter", {
          mailing_id: this.mailingId,
          query: { filter: "id" },
        });
        await this.reloadMailing();
      } else {
        await this.$store.dispatch("mailing/removeFilter", {
          mailing_id: this.mailingId,
          query: { filter: "query" },
        });
        await this.$store.dispatch("mailing/removeFilter", {
          mailing_id: this.mailingId,
          query: { filter: "id" },
        });
        await this.sendToEvery();
      }
    },
    async onSendModeClick(val: boolean) {
      try {
        this.forAllStitching = true;
        this.sendEvery = val;
        await this.onSendEveryChange(val);
        this.forAllStitching = false;
      } catch (error) {
        console.error("LOG: onSendModeClick -> error", error);
        this.forAllStitching = false;
      }
    },
  },
  async mounted() {
    await this.loadFiltersValues();
  },
  watch: {
    checkedStuds(newVal, oldVal) {
      let diff = newVal.length - oldVal.length;
      if (diff === 0) return false;
      let message = "";
      let type = "error";
      if (diff < -1) {
        message = `${this.$t("labels.deleted")} ${Math.abs(diff)} ${this.$t(
          "labels.users1"
        )}`;
      } else if (diff === -1) {
        message = `${this.$t(
          "labels.user"
        )} ${oldVal[0].getFullName()} ${this.$t("labels.deleted1")}`;
      } else if (diff === 1) {
        message = `${this.$t(
          "labels.user"
        )} ${newVal[0].getFullName()} ${this.$t("labels.added1")}`;
        type = "success";
      } else {
        message = `${this.$t("labels.added")} ${diff} ${this.$t(
          "labels.users1"
        )}`;
        type = "success";
      }
      this.$notify({
        // @ts-ignore
        title: this.$t("labels.success"),
        message,
        // @ts-ignore
        type,
      });
    },
    sendEvery(newVal) {
      // this.onSendEveryChange(newVal)
    },
  },
});
